module.exports = __webpack_public_path__ + "static/media/9.853f1177.png";